import { statTimesBest } from "stats/TimeStats";
import { CupModeTrack } from "../Set/CupMode/Track/CupModeTrack";
import { KnockoutTrack } from "../Set/Knockout/Track/KnockoutTrack";
import { MatchmakingTrack } from "../Set/Matchmaking/Track/MatchmakingTrack";
import { RoundsTrack } from "../Set/Rounds/Track/RoundsTrack";
import { TimeAttackTrack } from "../Set/TimeAttack/Track/TimeAttackTrack";
import { WorldTourTrack } from "../Set/WorldTour/Track/WorldTourTrack";
import { TrackRound } from "./TrackRound";

export type MatchTrackBase = {
  isComplete: boolean;
  trackId: string | undefined;
};

export type MatchTrack =
  | CupModeTrack
  | KnockoutTrack
  | MatchmakingTrack
  | RoundsTrack
  | TimeAttackTrack
  | WorldTourTrack;

export type NonTAMatchTrack =
  | CupModeTrack
  | KnockoutTrack
  | MatchmakingTrack
  | RoundsTrack
  | WorldTourTrack;

export type TrackBasedMatchTrack = MatchmakingTrack | WorldTourTrack;

export const matchTrackHasData = (track: MatchTrack) => {
  return false; // todo
};

export const matchTrackHasDriverData = (track: MatchTrack) => {
  return track.rounds.length > 0;
};

export const getMatchTrackPbForDriverIds = (
  track: NonTAMatchTrack,
  driverIds: string[]
) => {
  const times = track.rounds
    .flatMap((r) => r.times)
    .filter((t) => driverIds.includes(t.driverId));
  return statTimesBest(times);
};

export const getMatchTrackRounds = (matchTrack: MatchTrack) => {
  return matchTrack.rounds as TrackRound[];
};
